import React from 'react';

const MODES = [
  {
    id: 'cosmic',
    emoji: '✨',
    name: 'Космос',
    color: '#a78bfa',
    bg: 'linear-gradient(135deg, rgba(100,50,160,0.6), rgba(60,30,100,0.6))',
    border: 'rgba(167,139,250,0.4)',
    glow: 'rgba(167,139,250,0.25)',
    instructions: [
      '✦ ЛКМ — туманность',
      '✦ ПКМ — создать звезду',
      '✦ ПКМ×2 — чёрная дыра',
      '✦ Wheel — кольца',
    ]
  },
  {
    id: 'forest',
    emoji: '🌲',
    name: 'Лес',
    color: '#4ade80',
    bg: 'linear-gradient(135deg, rgba(30,80,50,0.6), rgba(10,50,30,0.6))',
    border: 'rgba(74,222,128,0.4)',
    glow: 'rgba(74,222,128,0.2)',
    instructions: [
      '✦ ЛКМ — посадить дерево',
      '✦ ПКМ — светлячки',
      '✦ ПКМ×2 — молния',
      '✦ Wheel — ветер / дождь',
    ]
  },
  {
    id: 'ocean',
    emoji: '🌊',
    name: 'Океан',
    color: '#38bdf8',
    bg: 'linear-gradient(135deg, rgba(10,60,120,0.6), rgba(5,30,80,0.6))',
    border: 'rgba(56,189,248,0.4)',
    glow: 'rgba(56,189,248,0.2)',
    instructions: [
      '✦ ЛКМ — косяк рыб',
      '✦ ПКМ — пузырьки',
      '❆ ПКМ×2 — биосвечение',
      '✦ Wheel — течение',
    ]
  },
  {
    id: 'garden',
    emoji: '🌸',
    name: 'Сад',
    color: '#f9a8d4',
    bg: 'linear-gradient(135deg, rgba(120,40,80,0.6), rgba(80,20,50,0.6))',
    border: 'rgba(249,168,212,0.4)',
    glow: 'rgba(249,168,212,0.2)',
    instructions: [
      '✦ ЛКМ — бабочки',
      '✦ ПКМ — цветок',
      '✦ ПКМ×2 — солнечный луч',
      '✦ Wheel — дождь',
    ]
  },
  {
    id: 'dream',
    emoji: '🌌',
    name: 'Сон',
    color: '#818cf8',
    bg: 'linear-gradient(135deg, rgba(40,20,100,0.6), rgba(20,10,60,0.6))',
    border: 'rgba(129,140,248,0.4)',
    glow: 'rgba(129,140,248,0.2)',
    instructions: [
      '✦ ЛКМ — звёздочки',
      '✦ ПКМ — аврора',
      '✦ ПКМ×2 — падающая звезда',
      '✦ Wheel — луна',
    ]
  },
  {
    id: 'peace',
    emoji: '🕊️',
    name: 'Мир',
    color: '#fda4af',
    bg: 'linear-gradient(135deg, rgba(120,30,60,0.6), rgba(80,20,40,0.6))',
    border: 'rgba(253,164,175,0.4)',
    glow: 'rgba(253,164,175,0.2)',
    instructions: [
      '✦ ЛКМ — сердечки',
      '✦ ПКМ — птички',
      '✦ ПКМ×2 — радуга',
      '✦ Wheel — ветерок',
    ]
  },
  {
    id: 'snake',
    emoji: '🐍',
    name: 'Змейка',
    color: '#4ade80',
    bg: 'linear-gradient(135deg, rgba(10,50,20,0.6), rgba(5,30,10,0.6))',
    border: 'rgba(74,222,128,0.4)',
    glow: 'rgba(74,222,128,0.2)',
    instructions: [
      '✦ Мышь управляет змейкой',
      '✦ Собирай цветные точки',
      '✦ Избегай себя',
      '✦ Скорость растёт с очками',
    ]
  },  {
    id: 'valentine',
    emoji: '💌',
    name: 'Валентинка',
    color: '#fb7185',
    bg: 'linear-gradient(135deg, rgba(120,20,60,0.6), rgba(80,10,40,0.6))',
    border: 'rgba(251,113,133,0.4)',
    glow: 'rgba(251,113,133,0.25)',
    instructions: [
      '❆ ЛКМ — письма-валентинки',
      '❆ ПКМ — сердечки',
      '❆ ПКМ×2 — большая валентинка',
      '❆ Wheel — волна любви',
    ]
  },];

const ModeSelector = ({ isOpen, currentMode, onSelect, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        style={{
          position: 'fixed', inset: 0, zIndex: 99990,
          background: 'rgba(0,0,0,0.0)', cursor: 'default'
        }}
      />

      {/* Panel */}
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
        position: 'absolute', bottom: 0, right: 'calc(100% + 12px)',
        zIndex: 99991,
        background: 'rgba(10,10,18,0.96)',
        backdropFilter: 'blur(28px)',
        WebkitBackdropFilter: 'blur(28px)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: '18px',
        padding: '14px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px',
        width: '340px',
        boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
      }}>
        {/* Header */}
        <div style={{
          gridColumn: '1 / -1',
          color: 'rgba(255,255,255,0.5)',
          fontSize: '11px',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          paddingBottom: '8px',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          marginBottom: '2px'
        }}>
          Выбор режима
        </div>

        {MODES.map(mode => {
          const isActive = currentMode === mode.id;
          return (
            <div
              key={mode.id}
              onClick={() => onSelect(mode.id)}
              style={{
                background: isActive ? mode.bg : 'rgba(255,255,255,0.03)',
                border: `1px solid ${isActive ? mode.border : 'rgba(255,255,255,0.08)'}`,
                borderRadius: '12px',
                padding: '10px 12px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: isActive ? `0 0 16px ${mode.glow}` : 'none',
              }}
              onMouseEnter={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.07)';
                  e.currentTarget.style.border = `1px solid ${mode.border}`;
                }
              }}
              onMouseLeave={e => {
                if (!isActive) {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.03)';
                  e.currentTarget.style.border = '1px solid rgba(255,255,255,0.08)';
                }
              }}
            >
              {/* Active checkmark */}
              {isActive && (
                <div style={{
                  position: 'absolute', top: '7px', right: '8px',
                  width: '16px', height: '16px',
                  background: mode.border,
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '9px'
                }}>✓</div>
              )}

              {/* Emoji */}
              <div style={{ fontSize: '22px', marginBottom: '5px', lineHeight: 1 }}>
                {mode.emoji}
              </div>

              {/* Name */}
              <div style={{
                color: isActive ? mode.color : 'rgba(255,255,255,0.8)',
                fontSize: '13px', fontWeight: '600', marginBottom: '6px'
              }}>
                {mode.name}
              </div>

              {/* Instructions */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                {mode.instructions.map((inst, i) => (
                  <div key={i} style={{
                    color: isActive ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.35)',
                    fontSize: '10px', lineHeight: '1.4'
                  }}>
                    {inst}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ModeSelector;
export { MODES };
